import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Share } from '@ifeng-fe/ui_pc_share';
import styles from './index.css';

class PhotoBottomInfo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    static defaultProps = {
        content: {},
    };

    /**
     * 插入html
     */
    createChannelInfo = () => {
        return { __html: this.props.content };
    };

    render() {
        const shareInfo = {
            url: 'photo.ifeng.com',
            title:
                '每张照片都重新证明时间的绵延连续不可停留，每张照片都是对我们生命必会消逝的提醒，每张照片都关乎生和死，每张定格的照片都有一层神圣的光晕。——Wim Wenders',
            summery:
                '每张照片都重新证明时间的绵延连续不可停留，每张照片都是对我们生命必会消逝的提醒，每张照片都关乎生和死，每张定格的照片都有一层神圣的光晕。——Wim Wenders',
            picUrl: '',
        };

        const config = {
            items: ['sina', 'qqzone'],
            display: 'normal',
            hover: 'hover',
            type: 'horizontal',
            methods: 'click',
            tooltip: 'top',
        };

        return (
            <div className={styles.bottomInfo}>
                <div className={styles.innerBox}>
                    <div dangerouslySetInnerHTML={this.createChannelInfo()} />
                    <div className={styles.shareBox}>
                        <Share config={config} shareInfo={shareInfo} />
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(PhotoBottomInfo);
